export default defineNuxtPlugin((nuxtApp) => {
    let player
    let players = {}
    let middleViewEl
    const defaultUrl = 'rtmp://bintu-splay.nanocosmos.de/splay'
    const defaultServer = {
        websocket: 'wss://bintu-h5live-secure.nanocosmos.de/h5live/authstream',
        hls: 'https://bintu-h5live-secure.nanocosmos.de/h5live/authhttp/playlist.m3u8',
    }
    let ip = ''
    const showIP = true
    let countRetry = 0
    const maxRetry = 10

    let enableSound = null

    /**
     * Lấy và cache phần tử DOM để giảm truy cập DOM không cần thiết
     */
    const domCache = {}
    function getElementByIdCached(id) {
        if (!domCache[id]) {
            domCache[id] = document.getElementById(id)
        }
        return domCache[id]
    }

    /**
     * Dọn dẹp DOM Cache khi player bị xóa
     */
    function cleanupDomCache(divId) {
        const keys = Object.keys(domCache).filter((key) => key.includes(divId))
        keys.forEach((key) => delete domCache[key])
    }

    function verifyToken(
        divId = '',
        groupId,
        streamName,
        site = 'bin88.com',
        isMute = true
    ) {
        if (!divId || !groupId) return
        console.log(`Verifying token for ${divId}`)
        const soundOffEl = getElementByIdCached(`soundoff-${divId}`)
        const soundOnEl = getElementByIdCached(`soundon-${divId}`)
        const blocktouchEl = getElementByIdCached(`blocktouch-${divId}`)

        try {
            const config = {
                source: {
                    entries: [
                        {
                            h5live: {
                                server: defaultServer,
                                rtmp: { url: defaultUrl, streamname: '' },
                                security: { jwtoken: '' },
                            },
                        },
                    ],
                },
                playback: {
                    autoplay: true,
                    automute: true,
                    muted: true,
                    faststart: true,
                },
                style: {
                    displayMutedAutoplay: false,
                    controls: false,
                    fullScreenControl: false,
                    interactive: true,
                },
                events: {
                    onReady: () => handlePlayerReady(divId),
                    onPlay: () => handlePlayerPlay(divId, isMute),
                    onError: () => handlePlayerError(divId),
                    onMute: () => setSoundOffEl(divId),
                    onUnmute: () => setSoundOnEl(divId),
                },
            }

            const xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function () {
                if (this.readyState === 4 && this.status === 200) {
                    const result = JSON.parse(this.response)
                    const data = result.data

                    if (data?.token) {
                        config.source.entries[0].h5live.security.jwtoken =
                            data.token
                    }
                    config.source.entries[0].h5live.rtmp.streamname = streamName

                    if (window.NanoPlayer) {
                        player = new window.NanoPlayer(divId)
                        player.setup(config).then(
                            () => {
                                console.log('Player setup success')
                            },
                            (error) =>
                                console.error('Player setup failed', error)
                        )

                        players[divId] = { player, isMute, isPlaying: false }
                        ip = result.ip
                        displayIP(ip)
                    }
                }
            }
            xhttp.onerror = () =>
                retryVerifyToken(divId, groupId, streamName, site)
            xhttp.ontimeout = () =>
                retryVerifyToken(divId, groupId, streamName, site)

            xhttp.open(
                'POST',
                'https://api-csn-s.gameland.today/api/v1/stream/',
                true
            )
            xhttp.setRequestHeader('Content-type', 'application/json')
            xhttp.send(JSON.stringify({ groupId, streamId: streamName, site }))

            preventTouch([blocktouchEl, soundOffEl, soundOnEl])
        } catch (error) {
            console.error('Error in verifyToken', error)
        }
    }

    function handlePlayerReady(divId) {
        middleViewEl = getElementByIdCached(`middleView-${divId}`)
        preventTouch([middleViewEl])
        localStorage.setItem(`stream-${divId}-error`, false)
    }

    function handlePlayerPlay(divId, isMute) {
        isMute = players[divId] ? players[divId].isMute : isMute
        if (isMute) setSoundOffEl(divId)
        else setSoundOnEl(divId)

        players[divId].isPlaying = true
        const divElement = getElementByIdCached(divId)
        if (divElement) divElement.style.display = 'block'
    }

    function handlePlayerError(divId) {
        localStorage.setItem(`stream-${divId}-error`, true)
        console.error(`Error with player ${divId}`)
        hideVideo(divId)
    }

    function retryVerifyToken(divId, groupId, streamName, site) {
        countRetry++
        if (countRetry <= maxRetry) {
            console.warn(
                `Retrying token for ${divId} (${countRetry}/${maxRetry})`
            )
            setTimeout(() => verifyToken(divId, groupId, streamName, site), 500)
        } else {
            console.error(`Max retries reached for ${divId}`)
            hideVideo(divId)
        }
    }

    function pause(divId) {
        if (players[divId]?.isPlaying) {
            players[divId].isPlaying = false
            players[divId].player.pause()
        }
    }

    function play(divId) {
        if (players[divId] && !players[divId].isPlaying) {
            players[divId].isPlaying = true
            players[divId].isMute = false
            players[divId].player.play()
        }
    }

    function soundOn(divId) {
        if (players[divId]?.isPlaying) {
            players[divId].isMute = false
            players[divId].player.unmute()
        }
    }

    function soundOff(divId) {
        if (players[divId]?.isPlaying) {
            players[divId].player.mute()
        }
        players[divId].isMute = true
    }

    function setSoundOnEl(divId) {
        const soundOffEl = getElementByIdCached(`soundoff-${divId}`)
        const soundOnEl = getElementByIdCached(`soundon-${divId}`)
        if (soundOffEl) soundOffEl.style.display = 'block'
        if (soundOnEl) soundOnEl.style.display = 'none'
        soundOn(divId)
    }

    function setSoundOffEl(divId) {
        const soundOffEl = getElementByIdCached(`soundoff-${divId}`)
        const soundOnEl = getElementByIdCached(`soundon-${divId}`)
        if (soundOffEl) soundOffEl.style.display = 'none'
        if (soundOnEl) soundOnEl.style.display = 'block'
        soundOff(divId)
    }

    function setPlayingEl(divId) {
        const playEl = getElementByIdCached(`play-${divId}`)
        const pauseEl = getElementByIdCached(`pause-${divId}`)
        if (pauseEl) pauseEl.style.display = 'block'
        if (playEl) playEl.style.display = 'none'
        play(divId)
    }

    function hideSoundEl(divId) {
        const soundOffEl = getElementByIdCached(`soundoff-${divId}`)
        const soundOnEl = getElementByIdCached(`soundon-${divId}`)
        if (soundOffEl) soundOffEl.style.display = 'none'
        if (soundOnEl) soundOnEl.style.display = 'none'
    }

    function cleanupPlayer(divId) {
        if (players[divId]) {
            players[divId].player.destroy()
            delete players[divId]
            cleanupDomCache(divId)
        }
    }

    function hideVideo(divId) {
        const middleViewEl = getElementByIdCached(`middleView-${divId}`)
        const videoElement = getElementByIdCached(`h5live-${divId}`)
        const videoThumbnail = getElementByIdCached(divId)

        if (middleViewEl) middleViewEl.style.display = 'none'
        if (videoElement) videoElement.style.display = 'none'
        if (videoThumbnail) videoThumbnail.style.backgroundColor = 'transparent'

        cleanupPlayer(divId)
    }

    function preventTouch(elements) {
        elements.forEach((el) => {
            if (el) {
                el.ontouchmove = (event) => event.preventDefault()
                el.ontouchstart = (event) => event.preventDefault()
            }
        })
    }

    function displayIP(ip) {
        if (ip && showIP) {
            const ipElement = getElementByIdCached('ipId')
            if (ipElement) ipElement.textContent = ip
        }
    }

    return {
        provide: {
            verifyToken,
            setSoundOnEl,
            setSoundOffEl,
        },
    }
})
